import { Scene } from "phaser";

export class BackgroundScene extends Scene {
  gameScene;
  layer;
  loadingImg;
  loadingText;
  rotate;

  constructor() {
    super("BackgroundScene");
  }

  preload() {
    const width = this.scale.gameSize.width;
    const height = this.scale.gameSize.height;

    this.loadingImg = this.add.image(width / 2, height / 2, "loading");
    this.loadingText = this.add
      .text(width / 2, height / 2 + 40, "Загрузка...", {
        fontSize: "16px",
        fill: "#ffffff",
      } as any)
      .setDepth(1)
      .setOrigin(0.5);

    this.load.multiatlas(
      "stars-hd",
      "assets/atlases/stars-hd.json",
      "assets/atlases"
    );

    this.load.multiatlas(
      "stars-fhd",
      "assets/atlases/stars-fhd.json",
      "assets/atlases"
    );
  }

  create() {
    const bg = this.add.image(0, 0, "background");

    this.rotate = this.add.image(50, 10, "rotate");
    this.rotate.setOrigin(0.5, 0.5);
    this.hideRotate();

    this.layer = this.add.container();
    this.layer.add(bg);
    this.layer.add(this.rotate);

    this.scene.launch("GameScene");
    this.gameScene = this.scene.get("GameScene");
  }

  public hideLoading() {
    this.loadingImg.setVisible(false);
    this.loadingText.setVisible(false);
  }

  public hideRotate() {
    this.rotate.setVisible(false);
  }

  public showRotate() {
    this.rotate.setVisible(true);
  }

  public updateCamera() {
    const width = this.scale.gameSize.width;
    const height = this.scale.gameSize.height;

    // const camera = this.cameras.main;

    //  There is 240px of extra padding below the game area in the background graphic
    //  so we account for it in the y offset (scaled by the game zoom factor)

    const zoom = this.gameScene.getZoom();
    const offset = 120 * zoom;

    //  We can either zoom and re-center the camera:

    // camera.setZoom(zoom);
    // camera.centerOn(1400 / 2, 1200 / 2 + 120);

    //  Or, if you want to put all of the Game Objects in this Scene into a layer,
    //  you can position and scale that:

    this.layer.x = width / 2;
    this.layer.y = height / 2 + offset;
    this.layer.setScale(zoom);
  }
}
